import BASE_URL from '../../utils/storage.js';

export const companyAPI = {
  /**
   * Get company information by company code
   * @param {string} companyCode - The company code (e.g., "TRANSPORT_SRL")
   * @returns {Promise<Object>} Company data with name, code, and address
   */
  async getByCode(companyCode) {
    try {
      if (!companyCode) {
        throw new Error('Company code is required');
      }

      const response = await fetch(`${BASE_URL}company/${companyCode}/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        if (response.status === 404) {
          throw new Error(`Company not found with code: ${companyCode}`);
        }
        throw new Error(`Failed to fetch company data: ${response.status}`);
      }

      const companyData = await response.json();
      return companyData;
    } catch (error) {
      console.error('Error fetching company by code:', error);
      throw error;
    }
  }
};

export default companyAPI;